import { render } from "./RiepilogoProvvigioni.vue?vue&type=template&id=ffd236fc&scoped=true"
import script from "./RiepilogoProvvigioni.vue?vue&type=script&lang=js"
export * from "./RiepilogoProvvigioni.vue?vue&type=script&lang=js"

import "./RiepilogoProvvigioni.vue?vue&type=style&index=0&id=ffd236fc&lang=css"
import "./RiepilogoProvvigioni.vue?vue&type=style&index=1&id=ffd236fc&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd236fc"]])

export default __exports__